const EQUIPMENT_IN_PROGRESS_STATUSES = new Set(['pending', 'writeRetry', 'written']);
const EQUIPMENT_FAILED_STATUSES = new Set(['writeFailed', 'syncFailed']);

export const getEquipmentSyncState = (equipment = [], { now, writtenThreshold } = {}) => {
  let failed = 0;
  let inProgress = 0;
  let synced = 0;
  equipment.forEach(({ status, lastUpdated } = {}) => {
    if (EQUIPMENT_FAILED_STATUSES.has(status)) {
      failed += 1;
    } else if (
      status === 'written'
      && now
      && writtenThreshold
      && lastUpdated
      && (now - lastUpdated >= writtenThreshold)
    ) {
      failed += 1;
    } else if (EQUIPMENT_IN_PROGRESS_STATUSES.has(status)) {
      inProgress += 1;
    } else if (status === 'synced') {
      synced += 1;
    }
  });
  return {
    failed,
    inProgress,
    written: synced,
    synced,
    total: equipment.length,
  };
};

export const isTimeEntrySynced = (task = {}) => {
  const latestStatus = task.statuses?.[0];
  return latestStatus?.resolved || latestStatus?.status === 'synced';
};

export const getRetryableEquipmentIds = (task = {}) => (
  (task.equipment ?? [])
    .filter(({ status } = {}) => (
      status === 'writeFailed'
      || status === 'writeRetry'
      || status === 'pending'
      || status === 'syncFailed'
    ))
    .map(({ id }) => id)
);

export const EQUIPMENT_FILTERS = [
  { text: 'None', value: 'none' },
  { text: 'Synced', value: 'synced' },
  { text: 'Pending', value: 'pending' },
  { text: 'Failed', value: 'failed' },
];

export const getUniqueFilters = (items, getValue, getText) => {
  if (!items?.length) return [];
  const seen = new Map();
  items.forEach((item) => {
    const value = getValue(item);
    if (value === undefined || value === null || seen.has(value)) return;
    seen.set(value, { text: getText(item, value), value });
  });
  return Array.from(seen.values()).sort((a, b) => a.text.localeCompare(b.text));
};

export const matchesEquipmentFilter = (value, equipment, options) => {
  const state = getEquipmentSyncState(equipment, options);
  switch (value) {
    case 'none':
      return state.total === 0;
    case 'failed':
      return state.failed > 0;
    case 'pending':
      return state.inProgress > 0 && !state.failed;
    case 'synced':
      return state.total > 0 && !state.failed && !state.inProgress;
    default:
      return false;
  }
};

export const formatEquipmentSyncSummary = (equipment, options) => {
  const {
    failed,
    inProgress,
    synced,
    written,
    total,
  } = getEquipmentSyncState(equipment, options);
  if (!total) return '-';
  if (failed) return `${failed} failed`;
  if (inProgress) return `${inProgress} pending`;
  return `${synced || written} synced`;
};
